import { For } from "solid-js";
import type { CompanyLookalike } from "~/lib/api";

type Props = {
  peers: CompanyLookalike[];
  onOpen: (slug: string) => void;
};

export function LookalikeChips(props: Props) {
  return (
    <div class="lookalike-chips">
      <For each={props.peers}>
        {(peer) => (
          <button type="button" class="lookalike-chip" onClick={() => props.onOpen(peer.slug)}>
            {peer.canonical_name}
          </button>
        )}
      </For>
    </div>
  );
}
